import { Component, Vue } from 'vue-property-decorator';
import { CustomBusiness } from '@/models/custom-business.model';
import { BusinessService } from '@/services';
import { APP } from '@/constants';


@Component
export default class DetailView extends Vue {

    public inFlight: boolean = false;
    public business: CustomBusiness = null;

    public mounted(): void {
        this.getData(this.$route.params.slug);
    }

    private async getData(slug) {
        this.inFlight = true;
        try {
            const response = await BusinessService.publicGet(slug);
            this.business = response.data;
            this.inFlight = false;
            document.title = 'Unternehmen: ' + this.business.name;
        } catch (error) {
            console.error('DetailView::getData – failed to business by slug: ', this.$route.params.slug);
            this.inFlight = false;
        }
    }

    public getLogoUrl(business: CustomBusiness): string {
        if (business && business.logo) {
            return `${APP.API_URL}/storage/business-logos/${business.uuid}/${business.logo}`;
        } else {
            return '';
        }
    }

    public getWebsiteUrl(business: CustomBusiness): string {
        if (business && business.website) {
            if (business.website.indexOf('http') === 0) {
                return business.website;
            } else {
                return `http://${business.website}`;
            }
        } else {
            return '';
        }
    }
}
